// time const in millisecond
export const SECOND = 1000;
export const MINUTE = 60 * SECOND; // 60 000
export const HOUR = 60 * MINUTE; // 3600000
export const DAY = 24 * HOUR; // 86400000
export const WEEK = 7 * DAY; // 604800000
export const YEAR = 365 * DAY; // 3,154e+10

